import { z } from 'zod'
import { baseSchema } from './base'

export const spanSchema = baseSchema
  .extend({
    type: z.literal('span'),
    text: z.string().describe('文字节点'),
  })
  .describe('插入 span 标签，用于输出文字或字符串模板')

export type SpanSchema = z.infer<typeof spanSchema>
